var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6516 11.596L17.9269 13.8713C18.2434 14.1878 18.2434 14.701 17.9269 15.0176C16.2156 16.7289 13.5063 16.9214 11.5702 15.4693L10.4619 14.6381C8.71838 13.3304 7.16955 11.7816 5.8619 10.0381L5.03067 8.92979C3.57858 6.99367 3.77112 4.28443 5.48243 2.57313C5.79896 2.2566 6.31215 2.2566 6.62868 2.57313L8.904 4.84845C9.29453 5.23897 9.29453 5.87214 8.904 6.26266L8.07488 7.09178C7.93063 7.23603 7.89487 7.45641 7.9861 7.63887C9.04091 9.74849 10.7515 11.4591 12.8611 12.5139C13.0436 12.6051 13.264 12.5694 13.4082 12.4251L14.2373 11.596C14.6279 11.2055 15.261 11.2055 15.6516 11.596Z",
    stroke: "#7161BA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.76057f58e964910ee16701ebe8fb10bd.svg";
export { ForwardRef as ReactComponent };